var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M10.0618938,6.00000002 C10.0210433,6.32759426 10,6.66133967 10,7.00000002 C10,7.69059916 10.087506,8.36076017 10.252035,9.00000002 L3,9.00000002 L3,6.00000002 L10.0618938,6.00000002 Z M11.0702576,11 C11.7965906,12.2556132 12.8543844,13.2954952 14.1239928,14 L3,14 L3,11 L11.0702576,11 Z M3,16 L21,16 L21,19 L3,19 L3,16 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 7,
    r: 6,
    fill: "#A9DDA8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuNotification);
export default __webpack_public_path__ + "static/media/MenuNotification.06741bfd.svg";
export { ForwardRef as ReactComponent };